import { useQuery } from '@tanstack/react-query';
import { ticketService } from '../../services/ticketService';

// Single source of truth: the support-service Ticket model, fetched via
// GET /support-service/meta/ticket-options. No static fallback.

const titleize = (v) =>
  String(v).replace(/_/g, ' ').replace(/^./, (c) => c.toUpperCase());

export const toOptions = (values = []) => values.map((v) => ({ value: v, label: titleize(v) }));

export const withAllStatuses = (statusOptions) => [{ label: 'All statuses', value: '' }, ...statusOptions];

/**
 * Ticket option lists, sourced from the backend (cached app-wide via react-query).
 * Returns ready-to-use { value, label } arrays (empty until loaded).
 */
export function useTicketOptions() {
  const { data } = useQuery({
    queryKey: ['ticket-options'],
    queryFn: async () => (await ticketService.getOptions())?.data,
    staleTime: 10 * 60 * 1000,
  });

  const status = toOptions(data?.statuses || []);
  const priority = toOptions(data?.priorities || []);
  const category = toOptions(data?.categories || []);

  return { status, priority, category, statusFilter: withAllStatuses(status) };
}
